      import React, { useEffect, useState } from "react";
      import { useParams, useNavigate } from "react-router-dom";
      import { MapPin, ArrowLeft } from "lucide-react";
      import axios from "axios";
      import "./upComingproject.css";
      import Navbar from "../components/Navbar/Navbar";
      import Footer from "../components/Footer/Footer";
      import { projects } from "./upcomingproject";

      const ProjectDetails = () => {
        const { slug } = useParams();
        const navigate = useNavigate();
const [successMessage, setSuccessMessage] = useState("");

        const project = projects.find((p) => p.slug === slug);

        const [formData, setFormData] = useState({
          name: "",
          email: "",
          phone: "",
          message: "",
        });

        const [loading, setLoading] = useState(false);

        useEffect(() => {
          window.scrollTo({ top: 0 });
        }, [slug]);

        if (!project) {
          return (
            <>
              <Navbar />
              <div style={{ padding: "60px", textAlign: "center" }}>
                <h2>Project not found</h2>
              </div>
              <Footer />
            </>
          );
        }

        // Handle change
        const handleChange = (e) => {
          const { name, value } = e.target;

          setFormData((prev) => ({
            ...prev,
            [name]: value,
          }));
        };

        // Submit enquiry
        // const handleSubmit = async (e) => {
        //   e.preventDefault();
        //   setLoading(true);

        //   try {
        //     await axios.post("http://localhost:5000/api/contact", {
        //       ...formData,
        //       projectName: project.title, // 🔥 send project name
        //     });

        //     alert("Enquiry Sent Successfully ✅");

        //     setFormData({
        //       name: "",
        //       email: "",
        //       phone: "",
        //       message: "",
        //     });

        //   } catch (error) {
        //     console.error(error);
        //     alert("Something went wrong ❌");
        //   } finally {
        //     setLoading(false);
        //   }
        // };

        const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
          const response = await axios.post(
            "https://knsonline.in/uat/RestAPI_V1/cp/v1/sendEmailToCustomer",
            JSON.stringify({
              name: formData.name,
              phone: formData.phone,
              email: formData.email,
              message: formData.message,
            }),
            {
            headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        }
            }
          );

          console.log("API Response:", response.data);

          setSuccessMessage("Thank you for your message. It has been sent.");

          setFormData({
            name: "",
            email: "",
            phone: "",
            message: "",
          });

          setTimeout(() => {
            setSuccessMessage("");
          }, 5000);

        } catch (error) {
          console.error("API Error:", error.response || error);
          setSuccessMessage("Something went wrong. Please try again.");
        } finally {
          setLoading(false);
        }
      };

        return (
          <>
            <Navbar />

            {/* BACK BUTTON */}
            <div className="back-container">
              <button className="back-btn33" onClick={() => navigate(-1)}>
                <ArrowLeft size={18} />
                Back to Projects
              </button>
            </div>

            {/* HERO IMAGE */}
            <section className="project-hero">
              <img src={project.image} alt={project.title} />
            </section>

            {/* MAIN CONTENT */}
            <section className="project-wrapper">

              {/* LEFT CONTENT */}
              <div className="project-left">

                <h1>{project.title}</h1>

                <div className="location-row">
                  <MapPin size={16} />
                  <span>{project.location}</span>
                </div>

                <div className={`status-badge ${project.statusType}`}>
                  {project.status}
                </div>

                <div className="description">
                  {project.overview?.paragraphs?.map((text, index) => (
                    <p key={index}>{text}</p>
                  ))}
                </div>

              </div>

              {/* RIGHT ENQUIRY CARD */}
              <div className="project-right">
                <div className="enquiry-card">
                  <h3>For More Details Enquire Now</h3>

                  <form className="enquiry-form" onSubmit={handleSubmit}>

                    <input
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />

                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />

                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />

                    <textarea
                      rows="4"
                      name="message"
                      placeholder="Your Message"
                      value={
                        formData.message ||
                        `I'm interested in ${project.title}`
                      }
                      onChange={handleChange}
                    />

                    <button type="submit" disabled={loading}>
                      {loading ? "Sending..." : "Submit Enquiry"}
                    </button>



                  </form>
                  {successMessage && (
  <div className="success-message">
    {successMessage}
  </div>
)}
                </div>
              </div>

            </section>

            <Footer />
          </>
        );
      };

      export default ProjectDetails;
